import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { LenticMark } from '../components/LenticMark';
import { EYEBROW } from '../components/site/Band';
import { Library } from '../components/site/Library';
export function Methodology() {
  return <>
      <section className="relative w-full overflow-hidden border-b border-mist bg-bone" data-id="element-483" data-mp="30nfnd7uc1k50">
        <div className="pointer-events-none absolute -right-40 -top-32 opacity-[0.12] lg:-right-20" data-id="element-484" data-mp="35lpjplrsmqs7">
          <LenticMark size={560} title={null} data-id="element-485" data-mp="3ahellvracjro" />
        </div>

        <div className="relative mx-auto w-full max-w-6xl px-6 py-24 lg:px-10 lg:py-32" data-id="element-486" data-mp="3fhk5uqv873zq">
          <p className={`${EYEBROW} text-teal`} data-id="element-487" data-mp="3k928djcwdcmt">Methodology</p>
          <h1 className="mt-5 max-w-3xl font-display text-[32px] font-light leading-[1.05] tracking-tight text-ink sm:text-[46px] lg:text-[56px]" data-id="element-488" data-mp="3kbogpl7m3w63">
            How a scenario is built, and how we know it still works.
          </h1>
          <p className="mt-8 max-w-[68ch] text-lg leading-relaxed text-graphite sm:text-xl" data-id="element-489" data-mp="22w83eiksc0o">
            The construction detail behind the assessment: the archetype
            primitives a scenario is assembled from, the safeguards that stop
            the set becoming a checklist, and the version discipline that makes
            a result reconstructable a year later.
          </p>

          <div className="mt-10 flex flex-wrap items-center gap-4" data-id="element-490" data-mp="2r71akcpjtlf9">
            <a href="/#how" className="inline-flex items-center gap-2 rounded-full border border-ink/15 px-6 py-3.5 text-base font-semibold text-ink transition-colors hover:border-ink/40" data-id="element-491" data-mp="2r8uidvbwebou">
              How the session works
            </a>
            <a href="/#record" className="inline-flex items-center gap-2 rounded-full border border-ink/15 px-6 py-3.5 text-base font-semibold text-ink transition-colors hover:border-ink/40" data-id="element-492" data-mp="3f2m66b8n5lhw">
              What the record contains
            </a>
          </div>
        </div>
      </section>

      <Library data-id="element-493" data-mp="pkvt3slufo2r" />

      <section className="w-full border-b border-mist bg-bone" data-id="element-494" data-mp="pkds6io8kloi">
        <div className="mx-auto flex w-full max-w-6xl flex-col gap-6 px-6 py-16 lg:flex-row lg:items-center lg:justify-between lg:px-10 lg:py-20" data-id="element-495" data-mp="pn8b25rlpyft">
          <p className="max-w-[60ch] font-display text-2xl font-light leading-snug text-ink" data-id="element-496" data-mp="griuca13ls8r">
            Scores are comparable within a locked library version, and we do not
            present them as comparable across versions or roles.
          </p>
          <a href="/#contact" className="inline-flex shrink-0 items-center gap-2 rounded-full bg-ink px-7 py-4 text-base font-semibold text-bone transition-colors hover:bg-teal" data-id="element-497" data-mp="6wqvz3zoz1cx">
            See pilot pricing
            <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-498" data-mp="1wcnjku6hped" />
          </a>
        </div>
      </section>
    </>;
}